import React, { ReactElement } from 'react';
import { Switch } from 'antd';


interface PageProps {
  value?: boolean
  onChange?: (value?: boolean | {}) => void;
}

interface PageState {

}

interface Page {

}

export default class JJ_FromSwitch extends React.Component<PageProps, PageState> implements Page {

  componentDidMount() {
  }

  constructor(props: any) {
    super(props);
    this.state = {}
  }

  render() {
    return (
      <Switch
        onChange={this.props.onChange}
        checked={this.props.value}
      />
    )
  }

}

